import { render, staticRenderFns } from "./DePager.vue?vue&type=template&id=4f181302"
import script from "./DePager.vue?vue&type=script&lang=js"
export * from "./DePager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f181302')) {
      api.createRecord('4f181302', component.options)
    } else {
      api.reload('4f181302', component.options)
    }
    module.hot.accept("./DePager.vue?vue&type=template&id=4f181302", function () {
      api.rerender('4f181302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/deCustomCm/DePager.vue"
export default component.exports